import util from '../util'

let controller = 'SolicitacaoAprovacaoLimite'

export default Object.assign({}, util.GetCrud(controller, ['post', 'get', 'put', 'getall', 'persist', 'delete']), {
  GetAllSolicitacoesPendenteLimite: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/SolicitacoesPendentes', dto)
  },
  AprovarReprovarSolicitacao: function (id, dto) {
    return util.Axios.Put(controller + '/SituacaoSolicitacao', id, dto)
  },
})
